import React, { useEffect, useState } from 'react';
import { Modal, ListGroup } from 'react-bootstrap';
import { Box, Tab, Tabs, IconButton, Typography } from '@mui/material';
import { InputField } from '../../../components/Common/FormikField/InputField';
import { Formik, Form } from 'formik';
import toastAlert from '../../../js/Base/ToastAlert';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import { getAccountById } from '../../../api/accountApi';
import {
  getCompanyGroupMembersByMemberId,
  getCompanyGroupNotInMember,
  getGroupsByIdList,
  deleteCompanyGroupMemberApi,
  addCompanyGroupMemberApi
} from '../../../api/companyApi';

const CompanyMemberEditModal = (props) => {
  const { companyMember, isModalOpen, handleClose } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [companyGroupMembers, setCompanyGroupMembers] = useState([]);
  const [nonJoinCompanyGroups, setNonJoinCompanyGroups] = useState([]);
  const [selectedGroupNo, setSelectedGroupNo] = useState(undefined);
  const [companyGroupMember, setCompanyGroupMember] = useState([]);
  const [companyGroup, setCompanyGroup] = useState([]);
  const [compGroupNotInclude, setCompGroupNotInclude] = useState([]);

  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    phone: "",
    timezone: "",
  });

  // 基本資料
  const resetFormData = () => {
    setInitialValues({
      name: "",
      email: "",
      phone: "",
      timezone: "",
    });
  };

  const getAccountByNo = async (acctUuid) => {
    try {
      const response = await getAccountById(acctUuid);
      const data = response.data;
  
      if (data.success && data.account) {
        setInitialValues({
          name: data.account.name || "",
          email: data.account.email || "",
          phone: data.account.tel || "",
          timezone: data.account.timezone || "",
        });
      } else {
        setInitialValues({
          name: companyMember?.name || "",
          email: companyMember?.email || "",
          phone: "",
          timezone: "",
        });
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    }
  };

  // 公司組織
  // 1. Modal 開啟時載入資料
  useEffect(() => {
    if (!isModalOpen) {
      resetFormData();
    }

    if (isModalOpen === true) {
      setActiveTab(0);
      setShowAddBtn(true);
      getAccountByNo(companyMember.acct_uuid);

      // 查詢已加入群組
      GetCompanyGroupMembersByCompanyMemberNo(companyMember.uuid).then((data) => {
        if (data.success) {
          setCompanyGroupMember(data.items);
        }
      });

      // 查詢未加入群組
      const companyUuid = localStorage.getItem("company_uuid");
      GetCompanyGroupNotInCompMember(companyUuid, companyMember.uuid).then(
        (data) => {
          if (data.success) {
            setCompGroupNotInclude(data.items);
          }
        }
      );
    }
  }, [isModalOpen, companyMember]);


  const GetCompanyGroupMembersByCompanyMemberNo = async (memberUuid) => {
    try {
      const response = await getCompanyGroupMembersByMemberId(memberUuid);
      return response.data;
    } catch (error) {
      if (error.__handled) return;
      return { success: false };
    }
  }
  
  const GetCompanyGroupNotInCompMember = async (companyUuid, memberUuid) => {
    try {
      const response = await getCompanyGroupNotInMember(companyUuid, memberUuid);
      return response.data;
    } catch (error) {
      if (error.__handled) return;
      return { success: false };
    }
  }


  // 2. 根據成員所屬群組查群組詳細資料
  useEffect(() => {
    if (companyGroupMember.length > 0) {
      const groupUuidList = companyGroupMember.map(item => item.group_uuid);
      GetCompanyGroupsByNoList(groupUuidList).then(data => {
        if (data.success) {
          setCompanyGroup(data.items);
        }
      });
    } else {
      setCompanyGroupMembers([]);
    }
  }, [companyGroupMember]);


  const GetCompanyGroupsByNoList = async (groupUuids = []) => {
    try {
      const response = await getGroupsByIdList(groupUuids);
      return response.data;
    } catch (error) {
      if (error.__handled) return;
      return { success: false };
    }
  }

  // 3. 把群組資料填回成員清單
  useEffect(() => {
    let copy_company_group_member = JSON.parse(JSON.stringify(companyGroupMember));
    for (let i = 0; i < copy_company_group_member.length; i++) {
      copy_company_group_member[i]["company_group_data"] = companyGroup.find(
        (group) => group.group_id === copy_company_group_member[i].group_id
      );
    }

    setCompanyGroupMembers(copy_company_group_member);
  }, [companyGroup]);

  // 4. 整理尚未加入的群組清單
  useEffect(() => {
    if (compGroupNotInclude?.length) {
      setNonJoinCompanyGroups(compGroupNotInclude);
    } else {
      setNonJoinCompanyGroups([]);
    }
  }, [compGroupNotInclude]);

  // 5. 刪除群組成員
  const deleteCompanyGroupMember = async (groupMemberUuid) => {
    try {
      const response = await deleteCompanyGroupMemberApi(groupMemberUuid);
      const data = response.data

      if (data.success) {
        toastAlert.autoClose(true).showSuccess('刪除成功');
        const companyUuid = localStorage.getItem("company_uuid");
        // 重新查詢 未加入 & 已加入群組
        GetCompanyGroupNotInCompMember(companyUuid, companyMember.uuid).then((data) => {
          if (data.success) {
            setCompGroupNotInclude(data.items);
          }
        });
  
        GetCompanyGroupMembersByCompanyMemberNo(companyMember.uuid).then((data) => {
          if (data.success) {
            setCompanyGroupMember(data.items);
          }
        });
      } else {
        toastAlert.autoClose(true).showError('刪除失敗，請稍後再試');
      }
      return data;
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('刪除失敗，請稍後再試');
    }
  };

  // 6. 新增群組成員
  const handleConfirm = () => {
    if (!selectedGroupNo || selectedGroupNo === 0) {
      toastAlert.autoClose(true).showError('請選擇單位');
      return;
    }
    AddCompanyGroupMember(selectedGroupNo, companyMember.uuid);
    setShowAddBtn(true);
  };

  const handleAddOption = () => {
    setShowAddBtn(false);
  };


  const AddCompanyGroupMember = async (selectedGroupUuid, companyMemberUuid) => {
    try {
      const response = await addCompanyGroupMemberApi(selectedGroupUuid, companyMemberUuid);
      const data = response.data
  
      if (data.success) {
        toastAlert.autoClose(true).showSuccess('新增成功');
        setSelectedGroupNo(undefined);
        setShowAddBtn(true);
        const companyUuid = localStorage.getItem("company_uuid");
  
        // 更新畫面資料
        GetCompanyGroupMembersByCompanyMemberNo(companyMember.uuid).then((d) => {
          if (d.success) setCompanyGroupMember(d.items);
        });
  
        GetCompanyGroupNotInCompMember(companyUuid, companyMember.uuid).then((d) => {
          if (d.success) setCompGroupNotInclude(d.items);
        });
      } else {
        toastAlert.autoClose(true).showError('新增失敗，請稍後再試');
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('新增失敗，請稍後再試');
    }
  };


  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCancel = () => {
    setSelectedGroupNo(undefined);
    setShowAddBtn(true);
  };

  const input_style = {
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    paddingLeft: '10px',
    borderRadius: '0px',
    fontSize: '14px',
  };

  return (
    <Modal
      animation="true"
      show={isModalOpen}
      onHide={handleClose}
      style={{ zIndex: '8999' }}
      className="CompanyManagement"
    >
      <div>
        <Modal.Header>
          <Modal.Title className="modal-title">編輯人員</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>
        {/* <Spin isLoading={!pageReady} className="spin"> */}
          <Modal.Body className="modal-body" style={{ paddingTop: '0px'}}>
            <Box sx={{ borderBottom: 2, borderColor: 'divider' }}>
              <Tabs
                TabIndicatorProps={{ style: { background: '#7FBE25' } }}
                style={{ paddingLeft: '20px' }}
                value={activeTab}
                onChange={handleChange}
              >
                <Tab
                  className={`text-tab ${activeTab === 0 && 'active'} `}
                  label="基本資料"
                  style={{
                    color: activeTab === 0 ? '#7FBE25' : '#757474',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    paddingBottom: '2px',
                  }}
                />
                <Tab
                  className={`text-tab ${activeTab === 1 && 'active'} `}
                  label="公司組織"
                  style={{
                    color: activeTab === 1 ? '#7FBE25' : '#757474',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    paddingBottom: '2px',
                  }}
                />
              </Tabs>
            </Box>
            {activeTab === 0 && (
              <Formik initialValues={initialValues} onSubmit={(values, { setSubmitting }) => {}} enableReinitialize={true}>
                {({ values, handleSubmit, setFieldValue, setSubmitting, resetForm, isSubmitting, errors, touched }) => (
                  <Form className="form">
                    <div className='form-item'>
                      <p className="form-title" style={{ fontWeight:'bold', margin: '1.5rem 0 0 0'}}>姓名</p>
                      <InputField
                        id="name"
                        name="name"
                        type="text"
                        className="input-field"
                        maxLength="100"
                        inputName="name"
                        style={input_style}
                        isReadOnly={true}
                      />
                    </div>
                    <div className='form-item'>
                      <p className="form-title" style={{ fontWeight:'bold', margin: '1.5rem 0 0 0'}}>電子信箱</p>
                      <InputField
                        id="email"
                        type="text"
                        className="input-field"
                        maxLength="100"
                        inputName="email"
                        style={input_style}
                        isReadOnly={true}
                      />
                    </div>
                    <div className='form-item'>
                      <p className="form-title" style={{ fontWeight:'bold', margin: '1.5rem 0 0 0'}}>電話</p>
                      <InputField
                        id="phone"
                        type="text"
                        className="input-field"
                        maxLength="100"
                        inputName="phone"
                        style={input_style}
                        isReadOnly={true}
                      />
                    </div>
                    <div className='form-item'>
                      <p className="form-title" style={{ fontWeight:'bold', margin: '1.5rem 0 0 0'}}>時區</p>
                      <InputField
                        id="timezone"
                        type="text"
                        className="input-field"
                        maxLength="100"
                        inputName="timezone"
                        style={input_style}
                        isReadOnly={true}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            )}
            {activeTab === 1 && (
              <div className="list-area">
                <ListGroup id="list-group" role="tablist" className="w-100">
                {companyGroupMembers.length > 0
                  ? companyGroupMembers.map((item) => (
                      <ListGroup.Item key={item.group_uuid} action className="list-item d-flex justify-content-between align-items-center">
                        <span>{item.company_group_data?.group_name ?? item.group_name}</span>
                        <Typography
                          className="hover-text"
                          onClick={() => deleteCompanyGroupMember(item.uuid)}
                        >
                          <CloseIcon fontSize="small" />
                        </Typography>
                      </ListGroup.Item>
                    ))
                    : ''}
                </ListGroup>
                {!showAddBtn && (
                  <div className="add-area">
                    <select
                      className="group-select"
                      onChange={(e) => setSelectedGroupNo((e.target.value))}
                    >
                      <option key={0} value={0}>
                        請選擇
                      </option>
                      {nonJoinCompanyGroups.map((m) => (
                        <option key={m.group_uuid} value={m.group_uuid}>
                          {m.group_name}
                        </option>
                      ))}
                    </select>

                    <div className="btn-wrapper">
                      <button className="btn-add" onClick={handleCancel}>
                        取消
                      </button>
                      <button className="btn-add" onClick={handleConfirm}>
                        確認
                      </button>
                    </div>
                  </div>
                )}

                {showAddBtn && nonJoinCompanyGroups.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'left', alignContent: 'center', margin: '15px 0px' }}>
                    <IconButton
                      onClick={() => handleAddOption()}
                        sx={{
                          color: "black",
                          width: 32,
                          height: 32,
                        }}
                      >
                      <Typography variant="h6" component="span" sx={{ lineHeight: 1 }}>
                        <AddIcon fontSize="medium" />
                      </Typography>
                  </IconButton>
                    <span
                      style={{ fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', alignSelf: 'center' }}
                      onClick={() => handleAddOption()}
                    >
                      新增更多選項
                    </span>
                  </div>
                )}
              </div>
            )}
          </Modal.Body>
      </div>
    </Modal>
  );
};

export default CompanyMemberEditModal;
